// This file was auto-generated by commondatabuilder.
// Please don't edit it.

import { t } from "@lingui/macro";
import { li18n } from '../frontend/lib/i18n-lingui';

export type IssueChoice = "HOME__MICE"|"HOME__RATS"|"HOME__COCKROACHES"|"HOME__NO_GAS"|"HOME__NO_HEAT"|"HOME__NO_HOT_WATER"|"HOME__NO_COLD_WATER"|"HOME__NO_SMOKE_DETECTOR"|"HOME__SMOKE_DETECTOR_DEFECTIVE"|"HOME__FLOOR"|"HOME__PAINTING"|"HOME__FRONT_DOOR_DEFECTIVE"|"HOME__DOOR_LOCK_DEFECTIVE"|"HOME__DOORBELL_DEFECTIVE"|"HOME__BUZZER_DEFECTIVE"|"HOME__LEAD_BASED_PAINT"|"HOME__VACATE_ORDER_ISSUED"|"HOME__MOLD"|"BEDROOMS__PAINT"|"BEDROOMS__WALLS"|"BEDROOMS__MOLD_ON_WALLS"|"BEDROOMS__WATER_DAMAGE"|"BEDROOMS__LOOSE_FLOOR"|"BEDROOMS__BASEBOARDS_DEFECTIVE"|"BEDROOMS__WINDOW_GLASS_BROKEN"|"BEDROOMS__WINDOW_FRAME_DEFECTIVE"|"BEDROOMS__DOOR"|"BEDROOMS__RADIATORS"|"BEDROOMS__CEILING"|"BEDROOMS__CEILING_LEAKING"|"BEDROOMS__ELECTRICITY"|"BEDROOMS__WIRING_EXPOSED"|"BEDROOMS__OUTLETS"|"KITCHEN__MOLD"|"KITCHEN__WATER"|"KITCHEN__PAINT"|"KITCHEN__WALLS"|"KITCHEN__LOOSE_FLOOR"|"KITCHEN__BASEBOARDS_DEFECTIVE"|"KITCHEN__WINDOW_GLASS_BROKEN"|"KITCHEN__WINDOW_FRAME_DEFECTIVE"|"KITCHEN__DOOR"|"KITCHEN__RADIATORS"|"KITCHEN__CEILING"|"KITCHEN__CEILING_LEAKING"|"KITCHEN__ELECTRICITY"|"KITCHEN__WIRING_EXPOSED"|"KITCHEN__OUTLETS"|"KITCHEN__REFRIGERATOR"|"KITCHEN__STOVE"|"KITCHEN__SINK"|"KITCHEN__FAUCET_LEAKING"|"KITCHEN__NO_FAUCET"|"KITCHEN__FAUCET_NOT_WORKING"|"KITCHEN__WATER_PRESSURE"|"KITCHEN__PIPES"|"KITCHEN__DRAIN"|"LIVING_ROOM__MOLD"|"LIVING_ROOM__WATER"|"LIVING_ROOM__PAINT"|"LIVING_ROOM__WALLS"|"LIVING_ROOM__LOOSE_FLOOR"|"LIVING_ROOM__BASEBOARDS_DEFECTIVE"|"LIVING_ROOM__WINDOW_GLASS_BROKEN"|"LIVING_ROOM__WINDOW_FRAME_DEFECTIVE"|"LIVING_ROOM__DOOR"|"LIVING_ROOM__RADIATORS"|"LIVING_ROOM__CEILING"|"LIVING_ROOM__CEILING_LEAKING"|"LIVING_ROOM__ELECTRICITY"|"LIVING_ROOM__WIRING_EXPOSED"|"LIVING_ROOM__OUTLETS"|"BATHROOMS__MOLD"|"BATHROOMS__WATER"|"BATHROOMS__PAINT"|"BATHROOMS__WALLS"|"BATHROOMS__LOOSE_FLOOR"|"BATHROOMS__BASEBOARDS_DEFECTIVE"|"BATHROOMS__WINDOW_GLASS_BROKEN"|"BATHROOMS__WINDOW_FRAME_DEFECTIVE"|"BATHROOMS__DOOR"|"BATHROOMS__RADIATORS"|"BATHROOMS__CEILING"|"BATHROOMS__CEILING_LEAKING"|"BATHROOMS__ELECTRICITY"|"BATHROOMS__WIRING_EXPOSED"|"BATHROOMS__OUTLETS"|"BATHROOMS__TOILET"|"BATHROOMS__TOILET_LEAKING"|"BATHROOMS__SINK"|"BATHROOMS__SINK_FAUCET_LEAKING"|"BATHROOMS__SINK_NO_FAUCET"|"BATHROOMS__SINK_FAUCET_NOT_WORKING"|"BATHROOMS__SINK_WATER_PRESSURE"|"BATHROOMS__SINK_PIPES"|"BATHROOMS__SINK_DRAIN"|"BATHROOMS__TUB"|"BATHROOMS__TUB_FAUCET_LEAKING"|"BATHROOMS__TUB_NO_FAUCET"|"BATHROOMS__TUB_FAUCET_NOT_WORKING"|"BATHROOMS__TUB_PIPES"|"BATHROOMS__TUB_DRAIN"|"BATHROOMS__SHOWER_MOLD"|"BATHROOMS__SHOWER_WATER_PRESSURE"|"BATHROOMS__SHOWER_PIPES"|"BATHROOMS__SHOWER"|"BATHROOMS__SHOWER_FAUCET_LEAKING"|"BATHROOMS__SHOWER_NO_FAUCET"|"BATHROOMS__SHOWER_DRAIN"|"PUBLIC_AREAS__PAINTING_OVERDUE"|"PUBLIC_AREAS__PAINT"|"PUBLIC_AREAS__NO_HEAT"|"PUBLIC_AREAS__NO_HOT_WATER"|"PUBLIC_AREAS__WATER_PRESSURE"|"PUBLIC_AREAS__RUSTY_WATER"|"PUBLIC_AREAS__WIRING_EXPOSED"|"PUBLIC_AREAS__ELECTRICAL_CURRENT"|"PUBLIC_AREAS__BUGS"|"PUBLIC_AREAS__PESTS"|"PUBLIC_AREAS__FUMES"|"PUBLIC_AREAS__SMOKE_DETECTORS"|"PUBLIC_AREAS__WINDOW_GUARDS"|"PUBLIC_AREAS__WASHING_MACHINE"|"PUBLIC_AREAS__DRYER"|"PUBLIC_AREAS__NO_SUPER"|"PUBLIC_AREAS__RENT_RECEIPTS"|"PUBLIC_AREAS__INCOMPLETE_RENT_RECEIPTS";

export const IssueChoices: IssueChoice[] = [
  "HOME__MICE",
  "HOME__RATS",
  "HOME__COCKROACHES",
  "HOME__NO_GAS",
  "HOME__NO_HEAT",
  "HOME__NO_HOT_WATER",
  "HOME__NO_COLD_WATER",
  "HOME__NO_SMOKE_DETECTOR",
  "HOME__SMOKE_DETECTOR_DEFECTIVE",
  "HOME__FLOOR",
  "HOME__PAINTING",
  "HOME__FRONT_DOOR_DEFECTIVE",
  "HOME__DOOR_LOCK_DEFECTIVE",
  "HOME__DOORBELL_DEFECTIVE",
  "HOME__BUZZER_DEFECTIVE",
  "HOME__LEAD_BASED_PAINT",
  "HOME__VACATE_ORDER_ISSUED",
  "HOME__MOLD",
  "BEDROOMS__PAINT",
  "BEDROOMS__WALLS",
  "BEDROOMS__MOLD_ON_WALLS",
  "BEDROOMS__WATER_DAMAGE",
  "BEDROOMS__LOOSE_FLOOR",
  "BEDROOMS__BASEBOARDS_DEFECTIVE",
  "BEDROOMS__WINDOW_GLASS_BROKEN",
  "BEDROOMS__WINDOW_FRAME_DEFECTIVE",
  "BEDROOMS__DOOR",
  "BEDROOMS__RADIATORS",
  "BEDROOMS__CEILING",
  "BEDROOMS__CEILING_LEAKING",
  "BEDROOMS__ELECTRICITY",
  "BEDROOMS__WIRING_EXPOSED",
  "BEDROOMS__OUTLETS",
  "KITCHEN__MOLD",
  "KITCHEN__WATER",
  "KITCHEN__PAINT",
  "KITCHEN__WALLS",
  "KITCHEN__LOOSE_FLOOR",
  "KITCHEN__BASEBOARDS_DEFECTIVE",
  "KITCHEN__WINDOW_GLASS_BROKEN",
  "KITCHEN__WINDOW_FRAME_DEFECTIVE",
  "KITCHEN__DOOR",
  "KITCHEN__RADIATORS",
  "KITCHEN__CEILING",
  "KITCHEN__CEILING_LEAKING",
  "KITCHEN__ELECTRICITY",
  "KITCHEN__WIRING_EXPOSED",
  "KITCHEN__OUTLETS",
  "KITCHEN__REFRIGERATOR",
  "KITCHEN__STOVE",
  "KITCHEN__SINK",
  "KITCHEN__FAUCET_LEAKING",
  "KITCHEN__NO_FAUCET",
  "KITCHEN__FAUCET_NOT_WORKING",
  "KITCHEN__WATER_PRESSURE",
  "KITCHEN__PIPES",
  "KITCHEN__DRAIN",
  "LIVING_ROOM__MOLD",
  "LIVING_ROOM__WATER",
  "LIVING_ROOM__PAINT",
  "LIVING_ROOM__WALLS",
  "LIVING_ROOM__LOOSE_FLOOR",
  "LIVING_ROOM__BASEBOARDS_DEFECTIVE",
  "LIVING_ROOM__WINDOW_GLASS_BROKEN",
  "LIVING_ROOM__WINDOW_FRAME_DEFECTIVE",
  "LIVING_ROOM__DOOR",
  "LIVING_ROOM__RADIATORS",
  "LIVING_ROOM__CEILING",
  "LIVING_ROOM__CEILING_LEAKING",
  "LIVING_ROOM__ELECTRICITY",
  "LIVING_ROOM__WIRING_EXPOSED",
  "LIVING_ROOM__OUTLETS",
  "BATHROOMS__MOLD",
  "BATHROOMS__WATER",
  "BATHROOMS__PAINT",
  "BATHROOMS__WALLS",
  "BATHROOMS__LOOSE_FLOOR",
  "BATHROOMS__BASEBOARDS_DEFECTIVE",
  "BATHROOMS__WINDOW_GLASS_BROKEN",
  "BATHROOMS__WINDOW_FRAME_DEFECTIVE",
  "BATHROOMS__DOOR",
  "BATHROOMS__RADIATORS",
  "BATHROOMS__CEILING",
  "BATHROOMS__CEILING_LEAKING",
  "BATHROOMS__ELECTRICITY",
  "BATHROOMS__WIRING_EXPOSED",
  "BATHROOMS__OUTLETS",
  "BATHROOMS__TOILET",
  "BATHROOMS__TOILET_LEAKING",
  "BATHROOMS__SINK",
  "BATHROOMS__SINK_FAUCET_LEAKING",
  "BATHROOMS__SINK_NO_FAUCET",
  "BATHROOMS__SINK_FAUCET_NOT_WORKING",
  "BATHROOMS__SINK_WATER_PRESSURE",
  "BATHROOMS__SINK_PIPES",
  "BATHROOMS__SINK_DRAIN",
  "BATHROOMS__TUB",
  "BATHROOMS__TUB_FAUCET_LEAKING",
  "BATHROOMS__TUB_NO_FAUCET",
  "BATHROOMS__TUB_FAUCET_NOT_WORKING",
  "BATHROOMS__TUB_PIPES",
  "BATHROOMS__TUB_DRAIN",
  "BATHROOMS__SHOWER_MOLD",
  "BATHROOMS__SHOWER_WATER_PRESSURE",
  "BATHROOMS__SHOWER_PIPES",
  "BATHROOMS__SHOWER",
  "BATHROOMS__SHOWER_FAUCET_LEAKING",
  "BATHROOMS__SHOWER_NO_FAUCET",
  "BATHROOMS__SHOWER_DRAIN",
  "PUBLIC_AREAS__PAINTING_OVERDUE",
  "PUBLIC_AREAS__PAINT",
  "PUBLIC_AREAS__NO_HEAT",
  "PUBLIC_AREAS__NO_HOT_WATER",
  "PUBLIC_AREAS__WATER_PRESSURE",
  "PUBLIC_AREAS__RUSTY_WATER",
  "PUBLIC_AREAS__WIRING_EXPOSED",
  "PUBLIC_AREAS__ELECTRICAL_CURRENT",
  "PUBLIC_AREAS__BUGS",
  "PUBLIC_AREAS__PESTS",
  "PUBLIC_AREAS__FUMES",
  "PUBLIC_AREAS__SMOKE_DETECTORS",
  "PUBLIC_AREAS__WINDOW_GUARDS",
  "PUBLIC_AREAS__WASHING_MACHINE",
  "PUBLIC_AREAS__DRYER",
  "PUBLIC_AREAS__NO_SUPER",
  "PUBLIC_AREAS__RENT_RECEIPTS",
  "PUBLIC_AREAS__INCOMPLETE_RENT_RECEIPTS"
];

const IssueChoiceSet: Set<String> = new Set(IssueChoices);

export function isIssueChoice(choice: string): choice is IssueChoice {
  return IssueChoiceSet.has(choice);
}

export type IssueChoiceLabels = {
  [k in IssueChoice]: string;
};

export function getIssueChoiceLabels(): IssueChoiceLabels {
  return {
    HOME__MICE: li18n._(t`Mice`),
    HOME__RATS: li18n._(t`Rats`),
    HOME__COCKROACHES: li18n._(t`Cockroaches`),
    HOME__NO_GAS: li18n._(t`No gas`),
    HOME__NO_HEAT: li18n._(t`No heat`),
    HOME__NO_HOT_WATER: li18n._(t`No hot water`),
    HOME__NO_COLD_WATER: li18n._(t`No cold water`),
    HOME__NO_SMOKE_DETECTOR: li18n._(t`No smoke detector`),
    HOME__SMOKE_DETECTOR_DEFECTIVE: li18n._(t`Smoke detector not working`),
    HOME__FLOOR: li18n._(t`Floor sags`),
    HOME__PAINTING: li18n._(t`Apartment needs painting`),
    HOME__FRONT_DOOR_DEFECTIVE: li18n._(t`Front door not working`),
    HOME__DOOR_LOCK_DEFECTIVE: li18n._(t`Door lock not working`),
    HOME__DOORBELL_DEFECTIVE: li18n._(t`Doorbell not working`),
    HOME__BUZZER_DEFECTIVE: li18n._(t`Buzzer not working`),
    HOME__LEAD_BASED_PAINT: li18n._(t`Lead-based paint`),
    HOME__VACATE_ORDER_ISSUED: li18n._(t`Vacate order issued`),
    HOME__MOLD: li18n._(t`Mold`),
    BEDROOMS__PAINT: li18n._(t`Peeling paint`),
    BEDROOMS__WALLS: li18n._(t`Cracked walls`),
    BEDROOMS__MOLD_ON_WALLS: li18n._(t`Mold on walls`),
    BEDROOMS__WATER_DAMAGE: li18n._(t`Water damage`),
    BEDROOMS__LOOSE_FLOOR: li18n._(t`Loose floor`),
    BEDROOMS__BASEBOARDS_DEFECTIVE: li18n._(t`Baseboards defective`),
    BEDROOMS__WINDOW_GLASS_BROKEN: li18n._(t`Window glass broken`),
    BEDROOMS__WINDOW_FRAME_DEFECTIVE: li18n._(t`Window frame defective`),
    BEDROOMS__DOOR: li18n._(t`Door not working`),
    BEDROOMS__RADIATORS: li18n._(t`Radiators/risers not working`),
    BEDROOMS__CEILING: li18n._(t`Ceiling falling/fell`),
    BEDROOMS__CEILING_LEAKING: li18n._(t`Ceiling leaking`),
    BEDROOMS__ELECTRICITY: li18n._(t`Electricity not working`),
    BEDROOMS__WIRING_EXPOSED: li18n._(t`Electric wiring exposed`),
    BEDROOMS__OUTLETS: li18n._(t`Outlets not working`),
    KITCHEN__MOLD: li18n._(t`Mold on walls`),
    KITCHEN__WATER: li18n._(t`Water damage`),
    KITCHEN__PAINT: li18n._(t`Peeling paint`),
    KITCHEN__WALLS: li18n._(t`Cracked walls`),
    KITCHEN__LOOSE_FLOOR: li18n._(t`Loose floor`),
    KITCHEN__BASEBOARDS_DEFECTIVE: li18n._(t`Baseboards defective`),
    KITCHEN__WINDOW_GLASS_BROKEN: li18n._(t`Window glass broken`),
    KITCHEN__WINDOW_FRAME_DEFECTIVE: li18n._(t`Window frame defective`),
    KITCHEN__DOOR: li18n._(t`Door not working`),
    KITCHEN__RADIATORS: li18n._(t`Radiators/risers not working`),
    KITCHEN__CEILING: li18n._(t`Ceiling falling/fell`),
    KITCHEN__CEILING_LEAKING: li18n._(t`Ceiling leaking`),
    KITCHEN__ELECTRICITY: li18n._(t`Electricity not working`),
    KITCHEN__WIRING_EXPOSED: li18n._(t`Electric wiring exposed`),
    KITCHEN__OUTLETS: li18n._(t`Outlets not working`),
    KITCHEN__REFRIGERATOR: li18n._(t`Refrigerator not working`),
    KITCHEN__STOVE: li18n._(t`Stove not working`),
    KITCHEN__SINK: li18n._(t`Cracked sink`),
    KITCHEN__FAUCET_LEAKING: li18n._(t`Leaky faucet`),
    KITCHEN__NO_FAUCET: li18n._(t`Faucets not installed`),
    KITCHEN__FAUCET_NOT_WORKING: li18n._(t`Faucets not working`),
    KITCHEN__WATER_PRESSURE: li18n._(t`Inadequate water pressure`),
    KITCHEN__PIPES: li18n._(t`Pipes leaking`),
    KITCHEN__DRAIN: li18n._(t`Drain stoppage`),
    LIVING_ROOM__MOLD: li18n._(t`Mold on walls`),
    LIVING_ROOM__WATER: li18n._(t`Water damage`),
    LIVING_ROOM__PAINT: li18n._(t`Peeling paint`),
    LIVING_ROOM__WALLS: li18n._(t`Cracked walls`),
    LIVING_ROOM__LOOSE_FLOOR: li18n._(t`Loose floor`),
    LIVING_ROOM__BASEBOARDS_DEFECTIVE: li18n._(t`Baseboards defective`),
    LIVING_ROOM__WINDOW_GLASS_BROKEN: li18n._(t`Window glass broken`),
    LIVING_ROOM__WINDOW_FRAME_DEFECTIVE: li18n._(t`Window frame defective`),
    LIVING_ROOM__DOOR: li18n._(t`Door not working`),
    LIVING_ROOM__RADIATORS: li18n._(t`Radiators/risers not working`),
    LIVING_ROOM__CEILING: li18n._(t`Ceiling falling/fell`),
    LIVING_ROOM__CEILING_LEAKING: li18n._(t`Ceiling leaking`),
    LIVING_ROOM__ELECTRICITY: li18n._(t`Electricity not working`),
    LIVING_ROOM__WIRING_EXPOSED: li18n._(t`Electric wiring exposed`),
    LIVING_ROOM__OUTLETS: li18n._(t`Outlets not working`),
    BATHROOMS__MOLD: li18n._(t`Mold on walls`),
    BATHROOMS__WATER: li18n._(t`Water damage`),
    BATHROOMS__PAINT: li18n._(t`Peeling paint`),
    BATHROOMS__WALLS: li18n._(t`Cracked walls`),
    BATHROOMS__LOOSE_FLOOR: li18n._(t`Loose floor`),
    BATHROOMS__BASEBOARDS_DEFECTIVE: li18n._(t`Baseboards defective`),
    BATHROOMS__WINDOW_GLASS_BROKEN: li18n._(t`Window glass broken`),
    BATHROOMS__WINDOW_FRAME_DEFECTIVE: li18n._(t`Window frame defective`),
    BATHROOMS__DOOR: li18n._(t`Door not working`),
    BATHROOMS__RADIATORS: li18n._(t`Radiators/risers not working`),
    BATHROOMS__CEILING: li18n._(t`Ceiling falling/fell`),
    BATHROOMS__CEILING_LEAKING: li18n._(t`Ceiling leaking`),
    BATHROOMS__ELECTRICITY: li18n._(t`Electricity not working`),
    BATHROOMS__WIRING_EXPOSED: li18n._(t`Electric wiring exposed`),
    BATHROOMS__OUTLETS: li18n._(t`Outlets not working`),
    BATHROOMS__TOILET: li18n._(t`Toilet not working`),
    BATHROOMS__TOILET_LEAKING: li18n._(t`Toilet leaking`),
    BATHROOMS__SINK: li18n._(t`Sink: cracked sink`),
    BATHROOMS__SINK_FAUCET_LEAKING: li18n._(t`Sink: leaky faucet`),
    BATHROOMS__SINK_NO_FAUCET: li18n._(t`Sink: faucets not installed`),
    BATHROOMS__SINK_FAUCET_NOT_WORKING: li18n._(t`Sink: faucets not working`),
    BATHROOMS__SINK_WATER_PRESSURE: li18n._(t`Sink: low water pressure`),
    BATHROOMS__SINK_PIPES: li18n._(t`Sink: pipes leaking`),
    BATHROOMS__SINK_DRAIN: li18n._(t`Sink: drain stoppage`),
    BATHROOMS__TUB: li18n._(t`Bathtub: cracked tub`),
    BATHROOMS__TUB_FAUCET_LEAKING: li18n._(t`Bathtub: leaky faucet`),
    BATHROOMS__TUB_NO_FAUCET: li18n._(t`Bathtub: faucets not installed`),
    BATHROOMS__TUB_FAUCET_NOT_WORKING: li18n._(t`Bathtub: faucets not working`),
    BATHROOMS__TUB_PIPES: li18n._(t`Bathtub: pipes leaking`),
    BATHROOMS__TUB_DRAIN: li18n._(t`Bathtub: drain stoppage`),
    BATHROOMS__SHOWER_MOLD: li18n._(t`Shower: mold on walls`),
    BATHROOMS__SHOWER_WATER_PRESSURE: li18n._(t`Shower: wall tiles cracked`),
    BATHROOMS__SHOWER_PIPES: li18n._(t`Shower: wall tiles missing`),
    BATHROOMS__SHOWER: li18n._(t`Shower: not working`),
    BATHROOMS__SHOWER_FAUCET_LEAKING: li18n._(t`Shower: low water pressure`),
    BATHROOMS__SHOWER_NO_FAUCET: li18n._(t`Shower: leaky shower head`),
    BATHROOMS__SHOWER_DRAIN: li18n._(t`Shower: drain stoppage`),
    PUBLIC_AREAS__PAINTING_OVERDUE: li18n._(t`Painting overdue (3 years)`),
    PUBLIC_AREAS__PAINT: li18n._(t`Peeling/flaking paint`),
    PUBLIC_AREAS__NO_HEAT: li18n._(t`No heat`),
    PUBLIC_AREAS__NO_HOT_WATER: li18n._(t`No hot water`),
    PUBLIC_AREAS__WATER_PRESSURE: li18n._(t`Inadequate water pressure`),
    PUBLIC_AREAS__RUSTY_WATER: li18n._(t`Rusty water`),
    PUBLIC_AREAS__WIRING_EXPOSED: li18n._(t`Electric wiring exposed`),
    PUBLIC_AREAS__ELECTRICAL_CURRENT: li18n._(t`Weak electrical current`),
    PUBLIC_AREAS__BUGS: li18n._(t`Bug infestation`),
    PUBLIC_AREAS__PESTS: li18n._(t`Rats/mice`),
    PUBLIC_AREAS__FUMES: li18n._(t`Fumes/smoke entering apartment`),
    PUBLIC_AREAS__SMOKE_DETECTORS: li18n._(t`Broken/no smoke/Co2 detector`),
    PUBLIC_AREAS__WINDOW_GUARDS: li18n._(t`Window guards missing`),
    PUBLIC_AREAS__WASHING_MACHINE: li18n._(t`Washing machine not working`),
    PUBLIC_AREAS__DRYER: li18n._(t`Dryer not working`),
    PUBLIC_AREAS__NO_SUPER: li18n._(t`Inadequate/no super service`),
    PUBLIC_AREAS__RENT_RECEIPTS: li18n._(t`No rent receipts given`),
    PUBLIC_AREAS__INCOMPLETE_RENT_RECEIPTS: li18n._(t`Rent receipts incomplete`),
  };
}
